import PageLoadingScreen from "@/Components/Navigation/PageLoadingScreen";
import { msSincePageLoadStarted } from "@/utils/pageLoadClock";
import { useEffect, useState } from "react";

const SHOW_AFTER_MS = 1500;

/*
 * The loading screen for a page that has nothing on screen yet. It stays hidden
 * until the document has been loading for SHOW_AFTER_MS, so a fast load goes
 * straight to its page instead of flashing this screen. The delay counts from
 * the start of the document load, not from mounting, so loading stages that
 * follow each other (identity, providers, the page's chunk) never leave a blank
 * gap between two loading screens.
 */
export default function DelayedPageLoadingScreen() {
    const [isShown, setIsShown] = useState(
        () => msSincePageLoadStarted() >= SHOW_AFTER_MS,
    );

    useEffect(() => {
        if (isShown) {
            return;
        }

        const timer = setTimeout(
            () => setIsShown(true),
            SHOW_AFTER_MS - msSincePageLoadStarted(),
        );

        return () => clearTimeout(timer);
    }, [isShown]);

    return isShown ? <PageLoadingScreen /> : null;
}
